import React from 'react';
import {connect} from 'react-redux';
import axios from 'axios/index';
import * as _ from 'lodash';

import FontAwesome from 'react-fontawesome';
import Autocomplete2 from './AutoComplete2';
import './AsyncAutoComplete.css';
import {setDamageList} from '../../stores/CarDamage/DamageReducer';
import {
  setCarDetail,
  setCarID,
  setCarSize, setCarType,
} from '../../stores/CarDamage/CarReducer';
import $ from 'jquery';

class AsyncAutoComplete extends React.Component {

  constructor(props) {
    super(props);

    this.delay = null;

    this.state = {
      items: [],
      loading: false,
      urlCache: this.props.urlCache
    };
  }

  onSelect = (value, item) => {
    const {props, state} = this;
    props.onSelect(item);
  };

  onChange = (event, value) => {
    const {props, state} = this;

    props.onChange(value);

    // if (this.delay) {
    //   clearTimeout(this.delay);
    // }
    // this.delay = setTimeout(_ => {
      this.fetchOptions(value);
    // }, 500);

  };

  renderMenu = (items, value) => {
    const {state} = this;
    let {inTable,autoWidth} = this.props
    if (items.length==0) {
      if (inTable)
        $('.table-responsive').css( "overflow-x", "initial" );
      
      return <div></div>
    } else if (items.length<=10) {
      return <div className={'async-autocomplete-wrapper'}>
        <div className={"async-autocomplete "+(autoWidth?'auto-width':'fixed-width')}>
          <div className="item" style={{'display': state.loading ? 'block' : 'none'}}>
            <FontAwesome name="spinner" spin />
          </div>
          {items}
        </div>
      </div>;
    } else {
      if (inTable)
        $('.table-responsive').css( "overflow-x", "initial" );
      
      return <div className={'async-autocomplete-wrapper'}>
        <div className={"async-autocomplete fixed-height "+(autoWidth?'auto-width':'fixed-width')}>
          <div className="item" style={{'display': state.loading ? 'block' : 'none'}}>
            <FontAwesome name="spinner" spin />
          </div>
          {items}
        </div>
      </div>;
    }
    /*const {state} = this;
    if (state.loading) {
      return (
          <div className={'async-autocomplete-wrapper'}>
            <div className="async-autocomplete">
              <div className={'item'}>
                <FontAwesome name="spinner" spin />
              </div>
            </div>
          </div>
      );
    }

    if (items.lenght === 0 || value === '') {
      return (<div></div>);
    }

    return (
        <div className={'async-autocomplete-wrapper'}>
          <div className="async-autocomplete">
            {items}
          </div>
        </div>
    );*/
  };

  renderItem = (item, isHighlighted) => {
    const {props, state} = this;
    return (
        <div key={state.indexOf(item) || Math.random(10000)}
             className={`item ${isHighlighted
                ? 'item-highlighted'
                : ''}`}
        >{item[props.labelField || 'name']}
        </div>
    );
  };

  getItemValue = (item) => {
    const {props, state} = this;
    return item[props.valueField || 'value'];
  };

  setUrlCache(api_url) {
    let {urlCache} = this.state
    if (urlCache!=undefined) {          
      if (urlCache.first) {
        urlCache.url = api_url
        urlCache.first = false
        this.setState({urlCache:urlCache})
      } else {
        if (urlCache.url==api_url) {
          urlCache.status = true
          this.setState({urlCache:urlCache})
        } else {
          let sameUrl = urlCache.data.find((item,index)=>{
            return item.url==api_url
          })
          if (sameUrl!=undefined) {
            urlCache.url = api_url
            urlCache.status = true
            this.setState({urlCache:urlCache})
          } else {
            urlCache.url = api_url
            urlCache.status = false
            this.setState({urlCache:urlCache})
          }  
        }
      }
    }
  };

  fetchOptions(value = '') {
    let {urlCache} = this.state 
    const {props, state} = this;
    const {damage} = props;
    const {item, car} = damage;
    const {paint_flag, fix_flag, part_flag, stock_flag, itemnum, wage_itemnum, detail, work_no} = item;
    const {carType, carSize, wo} = car || {};
    let api_url = props.api_url || '';
    switch (props.autocomplete_type) {
      case 'damage':
        if (value.length < 3) { return false;}
        api_url = `/workdoc/autocomplete/damage?car_type=${carType.toUpperCase()}&term=${value}&q=${value}`;
        break;

      case 'wageprice':
        api_url = `/workdoc/autocomplete/wageprice?` +
                  `itemnum=${wage_itemnum}&car_size=${carSize}` +
                  `&paint_flag=${paint_flag}&fix_flag=${fix_flag}&part_flag=${part_flag}` +
                  `&wo=${work_no}` + // &term=${value}
                  `&desc=${detail}`;

        this.setUrlCache(api_url)  

        if (!wage_itemnum) {
          return this.setState({items: props.autocomplete_items || []});
        }
        break;

      case 'partprice':
        api_url = `/workdoc/autocomplete/partprice?` +
                  `brand=${car.carBrand}&model=${car.carModel}` +
                  `&wo=${work_no}` +
                  `&desc=${detail}`;
        this.setUrlCache(api_url)  
        break;  

      case 'damage_wage':
        if (value.length < 3) { return false;}
        api_url = `/workdoc/autocomplete/damage_wage?q=${value}` +
                  `&car_type=${carType}`;
        break;

      case 'damage_part':
        if (value.length < 3) { return false;}
        api_url = `/workdoc/autocomplete/damage_part?q=${value}` +
                  `&car_type=${carType}`;
        break;

      default:

        return this.setState({items: props.autocomplete_items || []});
    }
    
    if (((props.autocomplete_type=='wageprice'||props.autocomplete_type=='partprice')&&urlCache!=undefined&&!urlCache.status)||(props.autocomplete_type!='wageprice'&&props.autocomplete_type!='partprice')) {
        this.setState({loading: true});
        axios.get(api_url).
        then((response) => {
          const items = response.data && response.data.data || [];
          if (urlCache!=undefined) {
            urlCache.data.push({
              url: api_url,
              data: items
            })
          }
          // console.log(items);
          this.setState({items, loading: false, urlCache:urlCache});
        }).
        catch((error) => {
          this.setState({loading: false});
          // console.error(error);
        });
    } else if ((props.autocomplete_type=='wageprice'||props.autocomplete_type=='partprice')&&urlCache!=undefined&&urlCache.status) {
      let items = []
      urlCache.data.forEach((item,index)=>{
        if (item.url==urlCache.url)
          items = item.data
      })
      this.setState({items});
    }   
  };

  render() {
    const {props, state} = this;
    return (
        <Autocomplete2
            inputProps={{
              'id': props.id || 'autocomplete-' + Math.random(99999),
              'className': props.className,
              'style': props.style,
            }}
            wrapperStyle={{
              position: 'relative',
              display: 'inline-block',
              'width': '100%',
            }}
            wrapperProps={props.fetchOnClick ? {
              onClick: () => {
                // if (_.isEmpty(state.items)) {
                  this.fetchOptions(props.value);
                // }
              },
            } : {}}
            value={props.value}
            items={state.items}
            onSelect={this.onSelect}
            onChange={this.onChange}
            renderMenu={this.renderMenu}
            renderItem={(item, isHighlighted) => {
              const {props, state} = this;
              return (
                  <div key={state.items.indexOf(item) || Math.random(10000)}
                       className={`item ${isHighlighted
                      ? 'item-highlighted'
                      : ''}`}
                  >{item[props.labelField || 'name']}
                  </div>
              );
            }}
            getItemValue={this.getItemValue}
        />
    );
  }
}

AsyncAutoComplete.defualtProps = {
  inTable: false,
  autoWidth: false
}

export default connect(
    (state, props) => ({...state, ...props}),
)(AsyncAutoComplete);



// WEBPACK FOOTER //
// ./src/component/element/AsyncAutoComplete.js